// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetCompanyObserversResponseDto } from '../models';
/**
 * CompanyObserversApi - axios parameter creator
 */
export const CompanyObserversApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Company Observer
         * @param {string} companyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyObserver: async (companyId: string, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('addCompanyObserver', 'companyId', companyId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('addCompanyObserver', 'employeeId', employeeId)
            const localVarPath = `/api/v1/companies/{companyId}/observers`
                .replace('{companyId}', encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Company\'s Observers
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyObservers: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyObservers', 'companyId', companyId)
            const localVarPath = `/api/v1/companies/{companyId}/observers`
                .replace('{companyId}', encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Company Observer
         * @param {string} companyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCompanyObserver: async (companyId: string, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('removeCompanyObserver', 'companyId', companyId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('removeCompanyObserver', 'employeeId', employeeId)
            const localVarPath = `/api/v1/companies/{companyId}/observers/{employeeId}`
                .replace('{companyId}', encodeURIComponent(String(companyId)))
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyObserversApi - functional programming interface
 */
export const CompanyObserversApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyObserversApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Company Observer
         * @param {string} companyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCompanyObserver(companyId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyObserversApi.addCompanyObserver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Company\'s Observers
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyObservers(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompanyObserversResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyObservers(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyObserversApi.getCompanyObservers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Company Observer
         * @param {string} companyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCompanyObserver(companyId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyObserversApi.removeCompanyObserver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyObserversApi - factory interface
 */
export const CompanyObserversApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyObserversApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Company Observer
         * @param {string} companyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCompanyObserver(companyId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Company\'s Observers
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyObservers(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCompanyObserversResponseDto> {
            return localVarFp.getCompanyObservers(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Company Observer
         * @param {string} companyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCompanyObserver(companyId, employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyObserversApi - interface
 */
export interface CompanyObserversApiInterface {
    /**
     * 
     * @summary Add Company Observer
     * @param {string} companyId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get Company\'s Observers
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyObservers(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCompanyObserversResponseDto>;

    /**
     * 
     * @summary Remove Company Observer
     * @param {string} companyId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CompanyObserversApi - object-oriented interface
 */
export class CompanyObserversApi extends BaseAPI implements CompanyObserversApiInterface {
    /**
     * 
     * @summary Add Company Observer
     * @param {string} companyId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig) {
        return CompanyObserversApiFp(this.configuration).addCompanyObserver(companyId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Company\'s Observers
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyObservers(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyObserversApiFp(this.configuration).getCompanyObservers(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Company Observer
     * @param {string} companyId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeCompanyObserver(companyId: string, employeeId: string, options?: RawAxiosRequestConfig) {
        return CompanyObserversApiFp(this.configuration).removeCompanyObserver(companyId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}

